export default {
  costings: [],
  constants: [],
  calculated: {
    main: {
      summary: [],
      shift: [],
      van: [],
      total: [],
      equipment: [],
    },
    detailed: {
      labour: [],
      expenses: [],
      processing: [],
      additional: [],
    },
  },
  totals: [],
}
